import { Tooltip } from '@chakra-ui/core';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';

const CopyComponent = ({ copyValue, children }) => {
  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);

  const onCopy = () => {
    copy(copyValue);
    setCopyTooltipOpen(true);
    setTimeout(() => setCopyTooltipOpen(false), 15000);
  };

  const x = React.Children.map(children, (child) => {
    const props = { onClick: onCopy };
    if (React.isValidElement(child)) {
      return React.cloneElement(child, props);
    }
    return child;
  });

  return (
    <Tooltip isOpen={copyTooltipOpen} label="Copied to clipboard" hasArrow>
      {x[0]}
    </Tooltip>
  );
};

export default CopyComponent;
